import Modal from "../Modal/Modal";
import { useState } from "react";
import "./editTask.css";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

function EditTask({
  open,
  onClose,
  toEditMarka,
  toEditProduct,
  toEditMinFollowers,
  toEditPay,
  id,
}) {
  const [marka, setMarka] = useState(toEditMarka);
  const [product, setProduct] = useState(toEditProduct);
  const [minFollowers, setMinFollowers] = useState(toEditMinFollowers);
  const [minPay, setMinPay] = useState(toEditPay);

  /* function to update firestore */
  const handleUpdate = async (e) => {
    e.preventDefault();
    const taskDocRef = doc(db, "ilanlar", id);
    try {
      await updateDoc(taskDocRef, {
        marka,
        product,
        minFollowers,
        minPay,
      });
      onClose();
    } catch (err) {
      alert(err);
    }
  };

  return (
    <Modal modalLable="Edit Task" onClose={onClose} open={open}>
      <form onSubmit={handleUpdate} className="editTask">
        <input
          type="text"
          name="name"
          onChange={(e) => setMarka(e.target.value.toUpperCase())}
          value={marka}
        />
        <input
          type="text"
          name="surname"
          onChange={(e) => setProduct(e.target.value)}
          value={product}
        />
        <input
          type="text"
          name="username"
          onChange={(e) => setMinPay(e.target.value)}
          value={minPay}
        />
        <input
          type="text"
          name="age"
          onChange={(e) => setMinFollowers(e.target.value)}
          value={minFollowers}
        />

        <button type="submit">Edit</button>
      </form>
    </Modal>
  );
}

export default EditTask;
